import React, {useEffect} from "react";
import { useSelector } from "react-redux";
import classes from './error.module.scss';
import Footer from '../../sharedUI/Footer/Footer';
import PrimaryButton from '../../sharedUI/button/PrimaryButton';
import { useAppContent } from "../../../shared/AppContent";
import { parseContent } from '../../../shared/utility';
import {trackAdobeDncPages} from "../../../shared/AdobeUtility";

export const Error404 = () => {
    const currentAppState = useSelector((state) => state.AppState);
    const userDetail = useSelector((state) => state.User.UserDetail);
    const isDumpBased = useSelector((state) => state?.DumpData?.isDumpData);
    const { errorMaintainenceContent } = useAppContent();

    const RedirectToHelpScreen = () => {
        if(isDumpBased){
            window.location.href = `${window.location.origin}/sprint/employeeApply`;
        }
        else{
        if (currentAppState?.cardListDetails?.uniqueIdentifier) {
            window.location.pathname = `/${process.env.REACT_APP_NAME}/${currentAppState?.cardListDetails?.uniqueIdentifier}`
        } else {
            window.location.pathname = `/${process.env.REACT_APP_NAME}/`
            }
        }
    };
    
    useEffect(() => {
        let additionalArr={wipStepName:"error_404"};
        trackAdobeDncPages("error",currentAppState,"errorPage",userDetail,additionalArr);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={classes.errorContainer}>
            <div className={classes.contentContainer}>
                <div className={classes.textContainer}>
                    <h1 className={classes.errorText1}>{errorMaintainenceContent?.heading}</h1>
                    <p className={classes.errorText2}>{parseContent(errorMaintainenceContent?.subheading)}</p>
                    {/* <p className={classes.errorText2}>lost your way</p> */}
                    <PrimaryButton
                        label={errorMaintainenceContent?.button}
                        dataTestid="submit-button"
                        ext={"png"}
                        renditions={["2x"]}
                        handleClick={() => { RedirectToHelpScreen() }}
                        className={classes.button}
                        appState={currentAppState}
                    />
                </div>
            </div>
            <Footer className={classes.footer} />
        </div>
    );

}
export default Error404;
